import { render } from "./ArticleRecordView.vue?vue&type=template&id=23fb3058"
import script from "./ArticleRecordView.vue?vue&type=script&lang=js"
export * from "./ArticleRecordView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__